import React from 'react'
import { Page } from '../../components/page'
import Signin from '../../blocks/signin'

export default () => (
  <Page name="SIGNIN" title="Sign in">
    <Signin />
  </Page>
)
